import React, { useContext } from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { Link } from "gatsby";
import RatingStars from "../components/RatingStars";
import { Colors } from "../components/styles/Colors";
import { Header4, ProximaNova } from "../components/typography";
import { SecondaryButton } from "../components/Button";
import richText from "../utils/richText";
import { addOneTimeItem } from "../utils/StoreActions";
import { store } from "../utils/StoreContext";
import Breakpoints from "../components/styles/Breakpoints";

const Product = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 60px;
  flex-wrap: wrap;

  @media ${Breakpoints.desktop} {
    margin-bottom: 120px;
  }

  .gatsby-image-wrapper {
    width: 100%;
    margin-bottom: 30px;

    @media ${Breakpoints.desktop} {
      width: 40%;
      margin-bottom: 0;
    }
  }

  .info {
    width: 100%;

    @media ${Breakpoints.desktop} {
      width: 60%;
      padding-left: 80px;
    }

    ${Header4} {
      margin-bottom: 20px;
      color: ${Colors.hunter};
    }

    .text {
      color: ${Colors.hunter};
      opacity: 0.8;
      position: relative;
      margin-bottom: 30px;

      p {
        display: inline;
      }

      span:first-child {
        @media ${Breakpoints.desktop} {
          display: none;
        }
      }

      &:before {
        content: none;
        color: ${Colors.hunter};
        font-size: 64px;
        position: absolute;
        top: 0px;
        left: 0px;
        font-family: ${ProximaNova};
        font-weight: 300;
        line-height: 1;
        transform: translate(-110%, -20%);
        opacity: 0.7;

        @media ${Breakpoints.desktop} {
          content: "“";
        }
      }
    }

    .buttons {
      display: block;

      @media ${Breakpoints.desktop} {
        display: flex;
      }

      & > ${SecondaryButton}:first-child {
        border: 0;
        margin-bottom: 15px;

        @media ${Breakpoints.desktop} {
          margin-right: 20px;
          margin-bottom: 0px;
        }
      }

      & > ${SecondaryButton}:last-child {
        border: 1px solid ${Colors.sage};
        color: ${Colors.sage};
        background-color: transparent;
        transition: color 0.3s, background-color 0.3s;

        &:hover {
          background-color: ${Colors.sage};
          color: ${Colors.white};
        }
      }
    }
  }
`;

export default function KaramoProduct({ product }) {
  const { dispatch } = useContext(store);

  function buy() {
    let item = {
      name: product.product.name,
      selectedVariant: product.product.variants[0],
    };

    dispatch(addOneTimeItem(item, 1, true));
  }

  return (
    <Product>
      <Image fluid={product.image.fluid} />

      <div className="info">
        <div className="inner">
          <Header4>{product.product.name}</Header4>
          <div className="text">
            <span>“</span>
            {richText(product.description.raw)}
            <span>”</span>
          </div>
          <div className="buttons">
            <SecondaryButton onClick={buy}>Buy Now</SecondaryButton>

            <SecondaryButton as={Link} to="/shop">
              View More
            </SecondaryButton>
          </div>
        </div>
      </div>
    </Product>
  );
}
